// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/drone/src/src/models/accountModel';
import model_2 from '/drone/src/src/models/aiCharacter';
import model_4 from '/drone/src/src/models/aiImage';
import model_7 from '/drone/src/src/models/aiwriteState';
import model_8 from '/drone/src/src/models/aiWritingModel';
import model_9 from '/drone/src/src/models/aiWritingModelMock';
import model_10 from '/drone/src/src/models/annotationModel';
import model_11 from '/drone/src/src/models/commentModel';
import model_12 from '/drone/src/src/models/configModel';
import model_13 from '/drone/src/src/models/domCheck';
import model_14 from '/drone/src/src/models/editor';
import model_5 from '/drone/src/src/models/aiOutline';
import model_15 from '/drone/src/src/models/langModel';
import model_17 from '/drone/src/src/models/pageModel';
import model_3 from '/drone/src/src/models/aiGenerating';
import model_6 from '/drone/src/src/models/aiOutlineMock';
import model_16 from '/drone/src/src/models/materialListModel';
import model_18 from '/drone/src/src/models/pluginState';
import model_19 from '/drone/src/src/models/tabConfg';
import model_20 from '/drone/src/src/models/themeModel';
import model_21 from '/drone/src/src/models/wordSmith';
import model_22 from '/drone/src/src/.umi-production/plugin-initialState/@@initialState';
import model_23 from '/drone/src/src/.umi-production/plugin-qiankun-slave/qiankunModel';

export const models = {
model_1: { namespace: 'accountModel', model: model_1 },
model_2: { namespace: 'aiCharacter', model: model_2 },
model_4: { namespace: 'aiImage', model: model_4 },
model_7: { namespace: 'aiwriteState', model: model_7 },
model_8: { namespace: 'aiWritingModel', model: model_8 },
model_9: { namespace: 'aiWritingModelMock', model: model_9 },
model_10: { namespace: 'annotationModel', model: model_10 },
model_11: { namespace: 'commentModel', model: model_11 },
model_12: { namespace: 'configModel', model: model_12 },
model_13: { namespace: 'domCheck', model: model_13 },
model_14: { namespace: 'editor', model: model_14 },
model_5: { namespace: 'aiOutline', model: model_5 },
model_15: { namespace: 'langModel', model: model_15 },
model_17: { namespace: 'pageModel', model: model_17 },
model_3: { namespace: 'aiGenerating', model: model_3 },
model_6: { namespace: 'aiOutlineMock', model: model_6 },
model_16: { namespace: 'materialListModel', model: model_16 },
model_18: { namespace: 'pluginState', model: model_18 },
model_19: { namespace: 'tabConfg', model: model_19 },
model_20: { namespace: 'themeModel', model: model_20 },
model_21: { namespace: 'wordSmith', model: model_21 },
model_22: { namespace: '@@initialState', model: model_22 },
model_23: { namespace: '@@qiankunStateFromMaster', model: model_23 },
} as const
